import { render, staticRenderFns } from "./TargetCalendar.vue?vue&type=template&id=22580e18&"
import script from "./TargetCalendar.vue?vue&type=script&lang=js&"
export * from "./TargetCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports